import { useMemo } from "react";
import { SliceZoneC } from "@commercekit/prismic";
import { components } from "~/lib/prismic";
import type { HTMLComponent } from "../../../../../libs/react/src/lib/types";
import type { CustomContentPageResultType } from "~/routes-server/$slug/types";
import DefaultFaq from "~/lib/prismic/slices/FaqSection/variations/DefaultFaq";
import type { FaqSliceSliceDefault } from "prismicio-types";

type GroupedDefaultFaqProps = {
  slice: {
    mergedDefaultFaqSlices: Array<{id: string } & FaqSliceSliceDefault>;
  }
}
const GroupedDefaultFaq = ({ slice }: GroupedDefaultFaqProps) => {
  return (
    <div>
      <div className="container">
        <div className="row">
          {slice.mergedDefaultFaqSlices.map((item) => (
            <DefaultFaq slice={item} key={item.id} />
          ))}
        </div>
      </div>
    </div>
  )
}

const WvCustomContentPage: HTMLComponent<{
  customContentPageResult: CustomContentPageResultType;
}> = ({ customContentPageResult }) => {
  const customContentPage = customContentPageResult.customContentPage;
  const slices = customContentPage?.data.slices;
  const hasBusinessRegistrationForm = slices?.some(
    (slice) => slice.slice_type === "business_registration_form"
  );

  const mergedSlices = useMemo(() => {
    const source = slices ?? [];
    type SourceSlice = typeof source[number];

    const isDefaultFaq = (slice: SourceSlice): slice is FaqSliceSliceDefault =>
      slice.slice_type === "faq_slice" && slice.variation === "default";

    type GroupedFaqSlice = FaqSliceSliceDefault & {
      slice_type: "faq_slice_group";
      mergedDefaultFaqSlices: FaqSliceSliceDefault[];
    };

    const result: (SourceSlice | GroupedFaqSlice)[] = [];

    let i = 0;
    while (i < source.length) {
      const slice = source[i];

      if (isDefaultFaq(slice)) {
        const group: FaqSliceSliceDefault[] = [slice];

        let j = i + 1;
        while (j < source.length && isDefaultFaq(source[j])) {
          group.push(source[j]);
          j++;
        }

        result.push({
          ...slice,
          slice_type: "faq_slice_group",
          mergedDefaultFaqSlices: group,
        });

        i = j;
      } else {
        result.push(slice);
        i++;
      }
    }

    return result;
  }, [slices]);

  const normalizedComponents = {
    ...components,
    faq_slice_group: GroupedDefaultFaq,
  }
  
  return (
    <div>
      <SliceZoneC
        slices={mergedSlices}
        components={normalizedComponents}
        defaultComponent={({ slice }) => (
          <div className="hidden">{slice.slice_type}</div>
        )}
        context={hasBusinessRegistrationForm ? {
          phoneCodeCountries: customContentPageResult.phoneCodeCountries,
        } : undefined} 
      />
    </div>
  );
};
export default WvCustomContentPage;
